import { trainingTopics } from "@/content/site";

export function LearnGrid() {
  return (
    <ul
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 list-none p-0 m-0"
      aria-label="Skills you'll learn"
    >
      {trainingTopics.map((topic) => (
        <li
          key={topic}
          className="flex items-start gap-3 border rounded px-5 py-4 transition-colors"
          style={{ backgroundColor: "#1c1c1c", borderColor: "#333", color: "rgba(255,255,255,0.9)" }}
        >
          <span
            aria-hidden="true"
            className="mt-1 inline-block h-2 w-2 shrink-0 bg-brand-red rounded-full"
          />
          <span className="text-sm sm:text-base text-white/90">{topic}</span>
        </li>
      ))}
    </ul>
  );
}
